import { render, staticRenderFns } from "./SceneDetail.vue?vue&type=template&id=50641fec&scoped=true&"
import script from "./SceneDetail.vue?vue&type=script&lang=js&"
export * from "./SceneDetail.vue?vue&type=script&lang=js&"
import style0 from "./SceneDetail.vue?vue&type=style&index=0&id=50641fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50641fec",
  null
  
)

export default component.exports